// extracted by mini-css-extract-plugin
export default {"color":"Color_color__kvTpP","selected":"Color_selected__PCUTL","sample":"Color_sample__5y8+l"};